import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';
import { withTranslation } from "react-i18next";
import { AppConstant } from '../../constant/AppConstant';
import { launchAddDevice } from '../../utils/addDeviceRouting';
import { showInfo } from '../../services/toastService';

// eslint-disable-next-line react/prefer-stateless-function
 class Footer extends Component {

  render() {
    let self = this;
    const {t}=self.props;

    // SECURITY NOTE: Access token in URL for the legacy desktop Add Device flow.
    // This is an intentional exception to our security policy of not passing
    // tokens in URLs. The legacy flow at dash.kegtron.com needs the mDash
    // customer token, and that app is mDash-hosted so we cannot change its
    // receiving end to a one-time handoff token (audit M3). Mitigations:
    //   - the token rides the URL FRAGMENT (#/add?...) which browsers never
    //     send over the network, so it can't land in server logs
    //   - the URL is built at CLICK time (inside launchAddDevice) instead of
    //     being pre-rendered into an href, so the plaintext token never sits
    //     in the DOM where extensions/analytics could scrape it
    //   - addDeviceBaseUrl is https (the page's JS arrives MITM-proof)
    // Residual exposure: browser history of the destination URL.
    //
    // Platform routing (Pro Wi-Fi Provisioning): the token only rides the URL
    // on the desktop legacy path. iOS/Android launch the native app via a
    // secret-free custom scheme; the legacy URL is only used as Android's
    // optional "continue in browser" escape hatch (see addDeviceRouting.js).
    const openAddDevice = (ev) => {
      ev.preventDefault();
      launchAddDevice({
        isDemo: self.props.app.state.isDemo,
        lang: self.props.lang,
        ktok: self.props.app.state.ktok,
        onBrowserFallback: (browserUrl) => {
          // De-emphasized secondary affordance for Android: a dismissible,
          // clickable toast rather than a primary button.
          showInfo(t(AppConstant.CONTINUE_IN_BROWSER), {
            autoClose: 8000,
            onClick: () => window.location.assign(browserUrl),
          });
        },
      });
    };

    return (
      <footer class={style.footer}>
        <nav class='d-flex align-items-stretch'>
          <Link
            activeClassName={style.active}
            href='/sites'
            onClick={function () {
              self.props.app.setState({ headerName: t(AppConstant.SITES) });
            }}
          >
            <span class='fa-fw fa fa-home' style='width: 2em' />
            <div class='small'>{t(AppConstant.SITES)}</div>
          </Link>
          {/* <Link activeClassName={style.active} href="/add-device" onClick={function () { self.props.app.setState({ headerName: "Add Device" }) }}>
                        <span class="fa-fw fa fa-plus-circle" style="width: 2em" />
                        <div class="small">Add Device</div>
                    </Link> */}

          <a href='' onClick={openAddDevice}>
            <span class='fa-fw fa fa-plus-circle' style='width: 2em' />
            <div class='small'>{t(AppConstant.ADD_DEVICE)}</div>
          </a>

          <Link
            activeClassName={style.active}
            href='/reports'
            onClick={function () {
              self.props.app.setState({ headerName: t(AppConstant.REPORTS) });
            }}
          >
            <span class='fa-fw fa fa-file-text' style='width: 2em' />
            <div class='small'>{t(AppConstant.REPORTS)}</div>
          </Link>
          <Link
            activeClassName={style.active}
            href='/account'
            onClick={function () {
              self.props.app.setState({ headerName: t(AppConstant.ACCOUNT) });
            }}
          >
            <span class='fa-fw fa fa-user' style='width: 2em' />
            <div class='small'>{t(AppConstant.ACCOUNT)}</div>
          </Link>
        </nav>
      </footer>
    );
  }
}
export default withTranslation()(Footer);
